import React, { useEffect } from "react";
import { Box } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { FormProvider } from "react-hook-form";
// import { useVisionConstants } from "Hooks/vision/useVisionConstants";
// import  LoadingWidget  from "Components/index";
import PageHeader from "Components/PageHeader";
import { useStyles } from "../styles";
// import { getCompanyId } from "src/utils";
import {
  CompanyDetails,
  // loggedInUserDetails
} from "Recoil/LoggedInUserDetail/selector";
import { useRecoilValue } from "recoil";
// import { get } from "lodash";
// import { useToast } from "Hooks/useToast";
import CompanyStepper from "../CompanyStepper";
// import ButtonStepper from "Components/StepperVertical/ButtonStepper";
import Action from "./Action";
import { useOrganizationConstants } from "Hooks/organization/useOrganizationConstants";
// import { CompanyState } from "Recoil/LoggedInUserDetail/atom";

const CompanySetup = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  // const companyId = getCompanyId();
  // const { methods } = useVisionConstants();
  // const toaster = useToast();
  // const [loader, setLoader] = useState(false);
  const {
    activeStep,
    setActiveStep,
    methods,
    editOrganizationDetails,
    getActiveStep
  } = useOrganizationConstants();
  // const {
  //   watch,
  //   setValue,
  //   getValues,
  //   trigger,
  //   formState: { errors }
  // } = methods;

  let companyDetail = useRecoilValue(CompanyDetails);

  useEffect(() => {
    if (companyDetail?.onBoarding) {
      setActiveStep(getActiveStep(companyDetail.onBoarding));
    }
  }, [companyDetail?.onboarding]);

  useEffect(() => {
    if (companyDetail?.companyId) {
      editOrganizationDetails(companyDetail);
    }
  }, [companyDetail.companyId]);

  return (
    <main className={classes.content}>
      <Box flexGrow={1}>
        <FormProvider {...methods}>
          <form>
            <PageHeader containerWidth="md" title={"Organization Setup"}>
              <Action activeStep={activeStep} setActiveStep={setActiveStep} />
            </PageHeader>
            <CompanyStepper
              activeStep={activeStep}
              setActiveStep={setActiveStep}
            />
          </form>
        </FormProvider>
      </Box>
    </main>
  );
};

export default CompanySetup;
